import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from "../../store/reducers/modal";
import { getFromLocalStorage, saveToLocalStorage } from '../../utils/localStorageUtils';
import { cartsData, currencyData } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { setCartCount } from '../../store/reducers/auth';
import { getConvertedPrice } from '../../utils/Utilities';

const CartModal = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [carts, setCarts] = useState(getFromLocalStorage(cartsData));
    const [price, setPrice] = useState({});
    const isOpen = useSelector((state) => state.modals.cartModal);

    useEffect(() => {
        calculatePrice();
    }, [carts]);

    useEffect(()=> {
        setCarts(getFromLocalStorage(cartsData));
    } , [isOpen]);

    const calculatePrice = () => {

        let totalPrice = 0;

        let currency = getFromLocalStorage(currencyData);

        carts?.forEach((cart, index) => {
            let quantity = cart.quantity;
            let variant = cart.selected_variant;

            totalPrice += getConvertedPrice(variant.price) * quantity;
        });

        setPrice({
            'subTotal': totalPrice?.toFixed(2),
            'total': totalPrice?.toFixed(2),
            'currency': currency?.currency?.symbol
        })
    }

    const onBtnClose = () => {
        dispatch(closeModal("cartModal"))
    }

    const btnCheckoutClick = () => {
        onBtnClose();
        navigate('/checkout');
    }

    const handleDelete = (index) => {
        const updatedCarts = carts.filter((_, i) => i !== index);
        setCarts(updatedCarts);
        saveToLocalStorage(cartsData, updatedCarts);
        dispatch(setCartCount(updatedCarts.length));
    };

    if (!isOpen) return null;

    return (
        <>
            {/* <!-- Cart --> */}
            <div className="w3-ch-sideBar w3-bar-block w3-card-2 w3-animate-right" style={{ display: isOpen ? 'block' : 'none', right: 0 }} id="Cart">

                <div className="rightMenu-scroll">
                    <div className="d-flex align-items-center justify-content-between slide-head py-3 px-3">
                        <h4 className="cart_heading fs-md ft-medium mb-0">Carts List</h4>
                        <button onClick={onBtnClose} className="close_slide"><i className="ti-close"></i></button>
                    </div>
                    {carts?.length > 0 ?
                        <div className="right-ch-sideBar">

                            <div className="cart_select_items py-2">

                                {carts.map((cart, index) => {
                                    const item = cart;
                                    const variant = cart.selected_variant;

                                    return <div key={`cartmodal-${index}`} className="d-flex align-items-center justify-content-between br-bottom px-3 py-3">
                                        <div className="cart_single d-flex align-items-center">
                                            <div className="cart_selected_single_thumb">
                                                <a ><img src={item?.image} width="60" className="img-fluid" alt="" /></a>
                                            </div>


                                            <div className="cart_single_caption pl-2">
                                                <h4 className="product_title fs-sm ft-medium mb-0 lh-1">{item.name}</h4>

                                                {item.item_attributes.map((attr, index) => {
                                                    const valFilter = attr.attribute_values.find((i) => i.selected === true);
                                                    return <>
                                                        <span key={`cart-modal-item-${index}`} className="mb-0"><span className="text-dark ft-medium small">{attr.name}</span>, <span className="text-dark small">{valFilter?.value}</span></span>
                                                        <br />
                                                    </>
                                                })}


                                                <h4 className="fs-md ft-medium mb-0 lh-1">{`${price?.currency} ${getConvertedPrice(variant.price)}`}</h4>
                                            </div>
                                        </div>
                                        <div className="fls_last"><button
                                            className="close_slide gray"
                                            onClick={() => handleDelete(index)}
                                        >
                                            <i className="ti-close"></i>
                                        </button></div>
                                    </div>
                                })}

                                {price?.total > 0 &&
                                    <div className="d-flex align-items-center justify-content-between br-top br-bottom px-3 py-3">
                                        <h6 className="mb-0">Subtotal</h6>
                                        <h3 className="mb-0 ft-medium">{`${price.currency} ${price.subTotal}`}</h3>
                                    </div>}

                                <div className="cart_action px-3 py-3">
                                    <div className="form-group">
                                        <button type="button" onClick={() => btnCheckoutClick()} className="btn d-block full-width btn-dark">Checkout Now</button>
                                    </div>
                                    {/* <div className="form-group">
                                    <button type="button" className="btn d-block full-width btn-dark-light">Edit or View</button>
                                </div> */}
                                </div>

                            </div>
                        </div>
                        : <><p style={{ 'text-align': 'center' , justifyItems : 'center' , alignItems : 'center', 'fontSize': 20 }}>No items in cart</p></>}
                </div>
            </div>
        </>

    )
}

export default CartModal